import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import classNames from 'classnames';
import GridContainer from 'components/Grid/GridContainer.jsx';
import componentsStyle from 'assets/jss/material-kit-react/views/components.jsx';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { Reorder } from '@material-ui/icons';
import ProfileService from './ProfileService';
import ServiceFAQ from './ServiceFAQ';
import AddressOnMap from '../Map/AddressOnMap';
import * as actions from '../../actions';
import { connect } from 'react-redux';
import HOCLoader from '../HOC/HOCLoader';
import moment from 'moment';
import CaroselParallax from '../Parallax/CaroselParallax.jsx';
import { withTheme } from '@material-ui/core/styles';
import BusinessHoursPopup from './BusinessHoursPopup';
import AddNewWishlistPopup from './AddNewWishlistPopup';
import { secondsToHms } from '../../utils/config/constants.js';
import { FormattedMessage } from 'react-intl';
import withUser from '../HOC/HOCwithUser.jsx';
import MenuButton from '../Menu/MenuButton.js';
import { NotificationManager } from 'react-notifications';
import AppLinks from '../../components/About/AppLinks';
import ServiceReview from './ServiceReview';

class Detail extends Component {
    constructor(props) {
        super();
        this.state = {
            businessHoursOpen: false,
            bookingPopup: false,
            loginPopup: false,
            selectedServiceId: props.serviceId,
            selectedProviderId: props.providerId,
            itemId: '',
            isService: true,
            markedFav: props.data.isFavorite,
            wishListData: [],
            showAddNewWishlistPopup: false
        };
        this.props = {
            afterLoginUrl: props.afterLoginUrl
        };
    }
    renderBusinessHours = () => {
        this.setState({ businessHoursOpen: true });
    };

    closebusinessHoursPopup = () => {
        this.setState({ businessHoursOpen: false });
    };
    bookNow = (item, isService) => {

        console.log("setting propsssss:::::::::",this.props.userData)
        const bookingPopupOption = this.props.userData.name ? true : false;
        if (isService == true) {
            if (bookingPopupOption) {
                this.setState({
                    bookingPopup: true,
                    isService: isService
                });
            } else {
                this.props.history.push(`/user/signin`);
            }
        } else {
            if (bookingPopupOption) {
                this.setState({
                    bookingPopup: true,
                    itemId: item.key,
                    isService: isService
                });
            } else {
                this.props.history.push(`/user/signin`);
            }
        }
    };
    closeLoginPopup = () => {
        this.props.hideLoginPopup();
    };

    markFavorite = key => {
        this.props.markProviderFavoriteAction(
            {
                providerId: this.props.data.id,
                favId: key ? key : null
            },
            this.onDone
        );
    };
    onDone = (success, data) => {
        if (success) {
            this.setState({ markedFav: data.data });
            NotificationManager.success(data.message, 'Success');
        } else {
            this.props.showLoginPopup();
        }
    };
    renderMenuItems = () => {
        if (this.props.wishListData) {
            let menuItems = this.props.wishListData.map(item => ({
                action: item.key,
                label: item.name
            }));
            menuItems.push({
                action: 'addNew',
                label: 'Add New'
            });
            console.log({ menuItems });
            return menuItems;
        }
    };
    actionCallbacks(action, res) {
        if (action === 'addNew') {
            this.setState({
                clickValue: 'addNew',
                showAddNewWishlistPopup: true
            });
        } else {
            this.markFavorite(action);
        }
    }
    closeWishlistPopup = () => {
        this.setState({ showAddNewWishlistPopup: false });
    };
    renderServiceProfile = serviceId => {
        this.props.refreshData(this.props.data.id, serviceId);
    };
    getRatingStars = rating => {
        for (let i = 1; i <= rating; i++) {
            return <i className="fa fa-star" aria-hidden="true" />;
        }
    };
    render() {
        const {
            classes,
            data,
            afterLoginUrl,
            wishListData,
            wishlistLoader
        } = this.props;
        const {
            selectedServiceId,
            bookingPopup,
            selectedProviderId,
            itemId,
            isService,
            markedFav
        } = this.state;
        if (bookingPopup) {
            this.props.history.push({
                pathname: `/book/service/${selectedProviderId}/${selectedServiceId}/${itemId}`
            });
        }
        return (
            <HOCLoader loading={!this.props.data ? true : false}>
                <div className="detail-slider-main">
                    <section className="pg-list-1">
                        <div className="container">
                            <div className="row dflex-inherit align-items-end">
                                <div className="pg-list-1-left">
                                    <h3>{data.name}</h3>

                                    <div className="list-rat-ch">
                                        <span>{data.rating}</span>
                                        {this.getRatingStars(data.rating)}
                                    </div>

                                    <p>
                                        <b>Address:</b>
                                        {data.displayAddress.address_line1}
                                    </p>
                                    <div className="list-number pag-p1-phone">
                                        <ul>
                                            <li>
                                                <i
                                                    className="fa fa-phone"
                                                    aria-hidden="true"
                                                />
                                                {data.phone}
                                            </li>
                                            <li>
                                                <i
                                                    className="fa fa-envelope"
                                                    aria-hidden="true"
                                                />
                                                <FormattedMessage
                                                    id="prodetail.email"
                                                    defaultMessage="Email"
                                                />
                                                : {data.email}
                                            </li>
                                            <li>
                                                <i
                                                    className="fa fa-usd"
                                                    aria-hidden="true"
                                                />
                                                {data.startFrom}/{' '}
                                                <FormattedMessage
                                                    id="prodetail.hour"
                                                    defaultMessage="hour"
                                                />
                                            </li>
                                        </ul>

                                        <ul>
                                            {data.establishedOn && (
                                                <li>
                                                    <FormattedMessage
                                                        id="prodetail.establised"
                                                        defaultMessage="Established On"
                                                    />
                                                    :{' '}
                                                    {moment
                                                        .unix(
                                                            data.establishedOn /
                                                                1000
                                                        )
                                                        .format('MM-DD-YYYY')}
                                                </li>
                                            )}
                                            {data.website && (
                                                <li>{data.website}</li>
                                            )}

                                            <li
                                                style={{
                                                    color: this.props.theme
                                                        .palette.primary.main,
                                                    cursor: 'pointer'
                                                }}
                                                onClick={
                                                    this.renderBusinessHours
                                                }
                                            >
                                                <FormattedMessage
                                                    id="prodetail.opentill"
                                                    defaultMessage="Open till"
                                                />
                                                :{' '}
                                                {secondsToHms(
                                                    data.businessHours.endTime
                                                )}
                                            </li>
                                        </ul>
                                    </div>

                                    <div className="display-provider-content text-center d-flex">
                                        {this.props.userData.name &&
                                            (markedFav == 0 ? (
                                                <i
                                                    style={{
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={() =>
                                                        this.markFavorite('')
                                                    }
                                                    className="far fa-heart fa-2x"
                                                    title="Mark Favorite"
                                                />
                                            ) : (
                                                <i
                                                    style={{
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={() =>
                                                        this.markFavorite('')
                                                    }
                                                    className="fas fa-heart fa-2x"
                                                    title="One of your Favorite"
                                                />
                                            ))}

                                        <ul className="provider-basic-detail-ul">
                                            {this.props.userData.name != '' && (
                                                <li>
                                                    <div className="savebtn">
                                                        <MenuButton
                                                            rowData={
                                                                wishListData
                                                            }
                                                            items={this.renderMenuItems()}
                                                            menuId={'favorite'}
                                                            menuCallback={(
                                                                action,
                                                                rowData
                                                            ) =>
                                                                this.actionCallbacks(
                                                                    action,
                                                                    rowData
                                                                )
                                                            }
                                                            iconType={Reorder}
                                                        />
                                                        Save to List
                                                    </div>
                                                </li>
                                            )}
                                        </ul>
                                    </div>
                                </div>
                                <div className="pg-list-1-right">
                                    <div className="list-enqu-btn pg-list-1-right-p1">
                                        <ul>
                                            {/* <li
                                                onClick={() =>
                                                    this.actionCallbacks(
                                                        'addNew',
                                                        wishListData
                                                    )
                                                }
                                            >
                                                <a href="#ld-rew">
                                                    <i
                                                        className="fa fa-star-o"
                                                        aria-hidden="true"
                                                    />
                                                    Save to List
                                                </a>
                                            </li> */}

                                            <li>
                                                <a
                                                    href={'skype:' + data.phone}
                                                    target="_blank"
                                                >
                                                    <i
                                                        className="fa fa-phone"
                                                        aria-hidden="true"
                                                    />
                                                    Call Now
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="list-pg-bg">
                        <div className="container">
                            <div className="row dflex-inherit">
                                <div className="com-padd">
                                    <div className="list-pg-lt list-page-com-p">
                                        <div
                                            className="pglist-p1 pglist-bg pglist-p-com"
                                            id="ld-abour"
                                        >
                                            <div className="pglist-p-com-ti">
                                                <h3>
                                                    <FormattedMessage
                                                        id="prodetail.about"
                                                        defaultMessage="About Provider"
                                                    />
                                                </h3>{' '}
                                            </div>
                                            <div className="list-pg-inn-sp">
                                                {/* <div className="share-btn">
                                                    <ul>
                                                        <li>
                                                            <a href="#">
                                                                <i className="fa fa-facebook fb1" />{' '}
                                                                Share On
                                                                Facebook
                                                            </a>{' '}
                                                        </li>
                                                        <li>
                                                            <a href="#">
                                                                <i className="fa fa-twitter tw1" />{' '}
                                                                Share On Twitter
                                                            </a>{' '}
                                                        </li>
                                                        <li>
                                                            <a href="#">
                                                                <i className="fa fa-google-plus gp1" />{' '}
                                                                Share On Google
                                                                Plus
                                                            </a>{' '}
                                                        </li>
                                                    </ul>
                                                </div> */}
                                                <p>{data.description}</p>
                                            </div>
                                        </div>

                                        <div
                                            className="pglist-p2 pglist-bg pglist-p-com"
                                            id="ld-ser"
                                        >
                                            <div className="pglist-p-com-ti">
                                                <h3>
                                                    <span>
                                                        Services Offered
                                                    </span>
                                                </h3>
                                            </div>
                                            <div className="list-pg-inn-sp">
                                                <div className="pg-list-ser">
                                                    <ul className="row">
                                                        {data.allServices
                                                            .length > 0 &&
                                                            data.allServices
                                                                .slice(0, 6)
                                                                .map(
                                                                    (
                                                                        service,
                                                                        index
                                                                    ) => {
                                                                        return (
                                                                            <li
                                                                                style={{
                                                                                    cursor:
                                                                                        'pointer'
                                                                                }}
                                                                                onClick={() =>
                                                                                    this.renderServiceProfile(
                                                                                        service.key
                                                                                    )
                                                                                }
                                                                                key={
                                                                                    index
                                                                                }
                                                                                className="col-md-4 col-sm-6 col-xs-12"
                                                                            >
                                                                                <div className="pg-list-ser-p1">
                                                                                    <img
                                                                                        // style={{
                                                                                        //     height:
                                                                                        //         '200px'
                                                                                        // }}
                                                                                        src={
                                                                                            service
                                                                                                .image
                                                                                                .medium
                                                                                        }
                                                                                        alt="service"
                                                                                    />
                                                                                </div>
                                                                                <div className="pg-list-ser-p2">
                                                                                    <h4>
                                                                                        {
                                                                                            service.heading
                                                                                        }
                                                                                    </h4>
                                                                                </div>
                                                                            </li>
                                                                        );
                                                                    }
                                                                )}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        {data.banners.length > 0 && (
                                            <div
                                                className="pglist-p3 pglist-bg pglist-p-com"
                                                id="ld-gal"
                                            >
                                                <div className="pglist-p-com-ti">
                                                    <h3>
                                                        <span>
                                                            Photo Gallery
                                                        </span>
                                                    </h3>
                                                </div>
                                                <div className="list-pg-inn-sp">
                                                    <CaroselParallax
                                                        images={data.banners}
                                                    />
                                                </div>
                                            </div>
                                        )}

                                        <div
                                            className="pglist-p3 pglist-bg pglist-p-com"
                                            id="ld-book"
                                        >
                                            <div className="pglist-p-com-ti">
                                                <h3>
                                                    <FormattedMessage
                                                        id="prodetail.bookservice"
                                                        defaultMessage="Book Service"
                                                    />
                                                </h3>
                                            </div>
                                            <div className="list-pg-inn-sp">
                                                <ProfileService
                                                    data={data}
                                                    clickBookNow={(
                                                        serviceId,
                                                        isService
                                                    ) =>
                                                        this.bookNow(
                                                            serviceId,
                                                            isService
                                                        )
                                                    }
                                                    userData={
                                                        this.props.userData
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className="pglist-p3 pglist-bg pglist-p-com"
                                            id="ld-faq"
                                        >
                                            <div className="pglist-p-com-ti">
                                                <h3>
                                                    <FormattedMessage
                                                        id="prodetail.faq"
                                                        defaultMessage="FAQ"
                                                        className="detail-faq-section"
                                                    />
                                                </h3>
                                            </div>
                                            <div className="list-pg-inn-sp">
                                                <ServiceFAQ data={data} />
                                            </div>
                                        </div>
                                        <div
                                            className="pglist-p3 pglist-bg pglist-p-com"
                                            id="ld-rer"
                                        >
                                            <div className="pglist-p-com-ti">
                                                <h3>
                                                    <FormattedMessage
                                                        id="prodetail.reviews"
                                                        defaultMessage="Reviews"
                                                    />
                                                </h3>
                                            </div>
                                            <div className="list-pg-inn-sp">
                                                <div className="lp-ur-all-rat">
                                                    <ServiceReview
                                                        data={data}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="list-pg-rt">
                                        <div className="pglist-p3 pglist-bg pglist-p-com">
                                            <div className="pg-list-user-pro">
                                                <img
                                                    src={data.proImage.small}
                                                />
                                            </div>
                                            <div className="list-pg-inn-sp">
                                                <div className="list-pg-upro">
                                                    <h5>{data.businessName}</h5>
                                                    <p>{data.tagline}</p>
                                                    {/* <a
                                                        className="waves-effect waves-light btn-large full-btn list-pg-btn"
                                                        href="#!"
                                                    >
                                                        Contact User
                                                    </a> */}
                                                </div>
                                            </div>
                                        </div>

                                        <div className="pglist-p3 pglist-bg pglist-p-com">
                                            <div className="pglist-p-com-ti pglist-p-com-ti-right">
                                                <h3>
                                                    <FormattedMessage
                                                        id="prodetail.findmap"
                                                        defaultMessage="Find Us on Map"
                                                    />
                                                </h3>
                                            </div>
                                            <div className="list-pg-inn-sp">
                                                <div className="list-pg-map">
                                                    <AddressOnMap
                                                        lat={parseFloat(
                                                            data.displayAddress
                                                                .latitude
                                                        )}
                                                        lng={parseFloat(
                                                            data.displayAddress
                                                                .longitude
                                                        )}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <div
                        className={classNames(
                            classes.main,
                            classes.mainRaised + ' section provider-detail-page'
                        )}
                    >
                        <div className={classes.container}>
                            <GridContainer justify="center" />
                        </div>
                    </div>
                    <AppLinks settings={this.props.settings} />
                </div>
                {this.state.businessHoursOpen && (
                    <BusinessHoursPopup
                        isVisible={this.state.businessHoursOpen}
                        closePopup={this.closebusinessHoursPopup}
                        data={data.workingHours.timing_packet}
                    />
                )}

                {this.state.showAddNewWishlistPopup && (
                    <AddNewWishlistPopup
                        isVisible={this.state.showAddNewWishlistPopup}
                        closePopup={this.closeWishlistPopup}
                        data={data}
                    />
                )}
            </HOCLoader>
        );
    }
}
const mapStateToProps = ({ settings }) => {
    return {
        settings: settings
    };
};
const composedComponent = compose(
    withTheme(),
    withStyles(componentsStyle),
    connect(mapStateToProps, actions)
);
export default composedComponent(withUser(withRouter(Detail)));



// WEBPACK FOOTER //
// ./src/components/Providers/Detail.js